import { useSessionStorage } from "@checkout-core/hooks/UseSessionStorage";
import { SESSION_STORAGE_KEYS } from "@swiggy-private/core-ui";
import React from "react";

interface BillToCompanyContextValue {
    isSelected: boolean;
    setIsSelected: (selected: boolean) => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const DEFAULT_VALUE: BillToCompanyContextValue = {
    isSelected: false,
    setIsSelected: noop,
};

export const BillToCompanyContext = React.createContext<BillToCompanyContextValue>(DEFAULT_VALUE);

export const BillToCompanyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isSelected, setIsSelected] = useSessionStorage(SESSION_STORAGE_KEYS.BILL_TO_COMPANY_SELECTED, false);

    return (
        <BillToCompanyContext.Provider value={{ isSelected, setIsSelected }}>{children}</BillToCompanyContext.Provider>
    );
};

if (__DEV__) {
    BillToCompanyContext.displayName = "BillToCompanyContext";
}
